module.exports = __webpack_public_path__ + "static/media/pop-cms.48b6815f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/pop-cms.svg
// module id = 1123
// module chunks = 1